import { effect, signal } from "@preact/signals";
import { UserDetails } from "../services/AuthService";
import { createLogger } from "../utils/logger";

const USER_STORAGE_KEY = 'user';
const logger = createLogger('authSignal');

export const authUserSignal = signal<UserDetails | undefined>(readUser()); 

function readUser(){
    const currentUser = localStorage.getItem(USER_STORAGE_KEY);
    logger.debug(`currentUser:${currentUser}`);
    if(currentUser == undefined ||
         currentUser == null ||
          currentUser == '' ||
          currentUser == 'undefined'){
        return undefined;
    }
    else{
        return JSON.parse(currentUser);
    }
}

effect(()=>{
    //persist signal on localStorage
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(authUserSignal.value));
})